import { render, staticRenderFns } from "./UCIrvineChem51LCLabReport4ResultsAppendix.vue?vue&type=template&id=a0961e9a&scoped=true&"
import script from "./UCIrvineChem51LCLabReport4ResultsAppendix.vue?vue&type=script&lang=ts&"
export * from "./UCIrvineChem51LCLabReport4ResultsAppendix.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0961e9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFileInput,VForm,VRow})
